import { render, staticRenderFns } from "./houseedit.vue?vue&type=template&id=b28a6ea4&scoped=true&"
import script from "./houseedit.vue?vue&type=script&lang=js&"
export * from "./houseedit.vue?vue&type=script&lang=js&"
import style0 from "./houseedit.vue?vue&type=style&index=0&id=b28a6ea4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28a6ea4",
  null
  
)

component.options.__file = "houseedit.vue"
export default component.exports